module.exports = __webpack_public_path__ + "img/detect_overdue.fb87056c.png";